var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inviewAnimation)?_c('p',{class:[ _vm.alignment, _vm.noMargin ]},[_vm._t("default")],2):_c('p',{class:[ _vm.alignment, _vm.noMargin ],attrs:{"data-scroll":"","data-scroll-call":_vm.inviewAnimation,"data-scroll-offset":"40%, 40%"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }